<template>
  <div class="csv-convert-medicines-raku">
    <login-for-management v-slot="{ clinics }">
      <base-csv-import
        v-slot="{ uploadCsv }"
        titleText="薬剤物品コンバート(らく動物病院)"
        url="/csv-convert-medicines-raku"
        :clinics="clinics"
        :initialCsvData="makeInitialCsvData()"
        :makeConfirmText="makeConfirmText"
        @success="downloadCsv"
      >
        <div>変換元ファイル</div>
        <input type="file" @change="uploadCsv($event, 'priceInput')" />
      </base-csv-import>
    </login-for-management>
  </div>
</template>

<script>
import BaseCsvImport from '@/components/pages/BaseCsvImport'
import LoginForManagement from '@/components/pages/LoginForManagement'
import { stringify } from 'csv-stringify/lib/sync'
export default {
  name: 'CsvImportMedicinesRaku',

  components: {
    BaseCsvImport,
    LoginForManagement
  },

  computed: {},

  watch: {},

  methods: {
    makeInitialCsvData() {
      return {
        priceInput: null
      }
    },
    makeConfirmText(targetClinic) {
      return `「${targetClinic.name}」の薬剤物品データについて、\nインポート用のCSVを作成します。実行しますか？`
    },
    downloadCsv(res) {
      const allCsv = res.data.allCsv
      const csv1 = allCsv.medicineLargeClassesCsv
      const csv2 = allCsv.medicineMediumClassesCsv
      const csv3 = allCsv.medicineSmallClassesCsv
      const csv4 = allCsv.medicinesCsv
      if (csv1.length > 0) {
        const csvStr1 = this.makeCsvStr(csv1)
        const fileName1 = 'm01_medicine_large_classes.csv'
        this.downloadFunc(csvStr1, fileName1)
      }
      if (csv2.length > 0) {
        const csvStr2 = this.makeCsvStr(csv2)
        const fileName2 = 'm02_medicine_medium_classes.csv'
        this.downloadFunc(csvStr2, fileName2)
      }
      if (csv3.length > 0) {
        const csvStr3 = this.makeCsvStr(csv3)
        const fileName3 = 'm03_medicine_small_classes.csv'
        this.downloadFunc(csvStr3, fileName3)
      }
      if (csv4.length > 0) {
        const csvStr4 = this.makeCsvStr(csv4)
        const fileName4 = 'm04_medicine.csv'
        this.downloadFunc(csvStr4, fileName4)
      }
    },
    makeCsvStr(csv) {
      return stringify(csv, {
        cast: {
          boolean: function(value) {
            return value.toString()
          }
        },
        header: true,
        quoted: true
      })
    },
    downloadFunc(csvStr, fileName) {
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      const blob = new Blob([bom, csvStr], { type: 'text/csv' })
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, fileName)
      } else {
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = fileName
        anchor.click()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
